<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
               :collapse-action="true">
        <div class="vx-row">
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Name</label>
            <vs-input type="search" placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
          </div>
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Code</label>
            <vs-input type="search" placeholder="Search.." v-model="filters['code']" class="w-full mb-4 md:mb-0"/>
          </div>
        </div>
        <div class="mt-5 vx-row">
          <div class="w-full ml-auto vx-col">
            <vs-button class="float-right mr-4" size="small"
                       color="danger" type="border" icon-pack="feather" v-on:click="filters={}">CLEAR
            </vs-button>
          </div>
        </div>
      </vx-card>
      <vx-card class="">
        <div id="languages-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="languageList">
              <template slot="thead">
                <vs-th sort-key="name" width="20%">Name</vs-th>
                <vs-th sort-key="code" width="20%">Code</vs-th>
                <vs-th width="20%">Language Status</vs-th>
                <vs-th width="20%">Action</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>
                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>
                  <vs-td :data="data[indextr].status">
                    {{ data[indextr].status }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left" v-if="data[indextr].code != 'en'">
                        <vs-button @click.stop="updateItemType(data[indextr].id)" class="ml-3" size="small"
                                   color="warning" type="border" icon-pack="feather" icon="icon-edit-2"/>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vx-card>
    </div>
    <UpdateLanguage ref="updateLanguage"/>
  </div>

</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import Filter from "@/mixins/filter";
import UpdateLanguage from "@/components/popups/tenants/localizations/UpdateLanguage.vue";

const LocalizationRepository = RepositoryFactory.get('localization')
export default {
  name: "LanguageList",
  data() {
    return {
      filters: {},
      languageList: {},
      tenant_id: null,
    }
  },
  mixins: [Filter],
  components: {
    UpdateLanguage,
  },
  mounted() {
    this.getLanguagesList()
    this.tenant_id = this.$route.params.id
  },
  methods: {
    async refreshData() {
      await this.getLanguagesList()
    },
    async getLanguagesList() {
      await this.$vs.loading({container: '#languages-list-table', scale: 0.45})
      const {data} = await LocalizationRepository.getLanguages(this.tenant_id, false, this.filterQuery)
      this.languageList = data.data
      this.$vs.loading.close('#languages-list-table > .con-vs-loading')
    },
    filterQueryUpdate() {
      this.getLanguagesList()
    },
    async updateItemType(id) {
      await this.$refs.updateLanguage.openPopup(id)
    }
  }
}
</script>

<style scoped>

</style>
